export const PencilIcon = (): JSX.Element => {
  return <svg width="16" height="16" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.499146 9.64167V11.6683C0.499146 11.855 0.645812 12.0017 0.832479 12.0017H2.85915C2.94581 12.0017 3.03248 11.9683 3.09248 11.9017L10.3725 4.62833L7.87248 2.12833L0.599146 9.40167C0.532479 9.46833 0.499146 9.54833 0.499146 9.64167Z" fill="#3B353E"/>
    <path d="M12.3058 1.755L10.7458 0.195C10.4858 -0.065 10.0658 -0.065 9.80581 0.195L8.58581 1.415L11.0858 3.915L12.3058 2.695C12.5658 2.435 12.5658 2.015 12.3058 1.755Z" fill="#3B353E"/>
  </svg>
}
